import type { ProcessedCourse } from "@/common/course/types";
import getCoursePaymentOption from "./getCoursePaymentOption";
import { PAYMENT_FREE, PAYMENT_UPGRADABLE } from "./constants";

/**
 * Returns true when the course has an audit seat across its active runs.
 *
 * Implemented in terms of the existing payment-option logic so that all
 * "has audit seat" decisions in the app go through the same source of truth
 * as `showCourseModes` (which gates the "Ways to take" / certificate
 * sections via `paymentOption === PAYMENT_UPGRADABLE`).
 *
 * - `PAYMENT_FREE`        → audit only (one audit seat, no paid seats).
 * - `PAYMENT_UPGRADABLE`  → audit + at least one paid seat.
 * - `PAYMENT_PAID`        → no audit seat (verified / professional only).
 *
 * Verified-only courses must never display an audit CTA and should bypass
 * the LMS Choose-Your-Track (CYT) page.
 */
export default function hasAuditSeat(
  course: ProcessedCourse | null | undefined,
): boolean {
  if (!course) return false;
  const paymentOption = getCoursePaymentOption(course);
  return paymentOption === PAYMENT_FREE || paymentOption === PAYMENT_UPGRADABLE;
}
